(function () {
    'use strict';

    if (window.__collectionViewToggleReady) return;
    window.__collectionViewToggleReady = true;

    var ACTIVE = 'model-view-active';

    function isModelView() {
        return document.body.classList.contains(ACTIVE);
    }


    function syncButtons() {
        var pressed = isModelView() ? 'true' : 'false';
        document.querySelectorAll('.product-view-toggle').forEach(function (btn) {
            btn.setAttribute('aria-pressed', pressed);
        });
    }

    function applyMobileOrder(scope) {
        var want = isModelView() ? 'model' : 'product';
        var root = scope || document;
        var touched = false;

        root.querySelectorAll('[data-card-mobile-slider]').forEach(function (slider) {
            if ((slider.dataset.viewOrder || 'product') === want) return;

            // Solo invertir si hay una segunda imagen real.
            var card = slider.closest('[data-product-card]');
            var secondary = card && card.querySelector('[data-card-secondary-image]');
            if (!secondary || secondary.getAttribute('data-has-secondary') !== 'true') return;

            // Hay que desmontar slick antes: mientras esta activo los slides
            // viven dentro de .slick-track, no como hijos directos.
            if (window.jQuery && window.jQuery(slider).hasClass('slick-initialized')) {
                window.jQuery(slider).slick('unslick');
            }

            var slides = slider.querySelectorAll('.card-mobile-slide');
            if (slides.length < 2) return;

            slider.insertBefore(slides[1], slides[0]);
            slider.dataset.viewOrder = want;
            touched = true;
        });

        if (touched && typeof window.initMobileCardSliders === 'function') {
            window.initMobileCardSliders();
        }
    }

    function apply(scope) {
        syncButtons();
        applyMobileOrder(scope);
    }

    document.addEventListener('click', function (event) {
        var toggle = event.target.closest('.product-view-toggle');
        if (!toggle) return;

        event.preventDefault();
        document.body.classList.toggle(ACTIVE);
        apply();
    });


    window.addEventListener('click', function (event) {
        if (!event.target.closest('[data-linked-swatch]')) return;
        setTimeout(applyMobileOrder, 0);
        setTimeout(applyMobileOrder, 120);
    }, true);


    function observe(id) {
        var node = document.getElementById(id);
        if (!node || !window.MutationObserver) return;
        new MutationObserver(function () {
            apply(node);
        }).observe(node, { childList: true });
    }

    function init() {
        observe('ProductGridContainer');
        observe('main-collection-filters');
        apply();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
